@for (option of options(); track option) {
  <bspk-radio-option [checked]="option.value === selectedValue()"
                     [description]="option.description"
                     [disabled]="option.disabled"
                     [label]="option.label"
                     [name]="name()"
                     [size]="size()"
                     [value]="option.value"
                     (checkedChange)="onCheckedChange(option.value, $event)"
  />
}
@if (errorState()) {
  <bspk-inline-alert variant="error"><span [innerHTML]="errorState()"></span></bspk-inline-alert>
}
